<template>
  <v-app-bar
      app
      extended
      class="ramp-app-bar px-8"
      :class="{ 'header-minified': isMinified }"
  >
      <v-toolbar-title>
        <a href="/" alt="Home">
          <v-img
              :height="50"
              :max-width="265"
              :src="require('@/assets/images/transparent-bpo-logo.png')"
              contain
          ></v-img>
        </a>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <a href="/careers" class="ramp-nav-item no-mobile">Find Jobs</a>
      <a href="/careers" class="ramp-nav-item no-mobile">News</a>
      <v-btn
        v-if="accountMenu"
        variant="tonal"
        rounded="s"
        height="50"
        color="white"
        class="no-transform bold text-left  no-mobile"
      >
        {{ firstName }} {{ lastName }}
        <v-spacer></v-spacer>
        <v-icon class="mdi mdi-menu-down"></v-icon>
        <v-menu activator="parent">
          <v-card min-width="300">
            <v-list>
              <span v-if="completeInfo">
                <v-list-item href="/dashboard/candidate" v-if="completeInfo.full_data.role.id==='377da95c-6518-4715-b32d-ac9825cb42bd'">
                  <span class="text-center"><v-icon class="mdi mdi-account-circle"></v-icon> My Account</span>
                </v-list-item>
                <v-list-item href="/dashboard" v-else>
                  <span class="text-center"><v-icon class="mdi mdi-account-circle"></v-icon> My Account</span>
                </v-list-item>
              </span>
              <v-list-item href="/careers" else>
                <span class="text-center"><v-icon class="mdi mdi-tie"></v-icon> Careers</span>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item @click="logOut" class="header-menu-logout">
                <span @click="logOut" class="text-center"><v-icon class="mdi mdi-logout-variant"></v-icon> Log-out</span>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </v-btn>
      <v-btn v-else to="/login" variant="tonal" rounded="s" height="50" class="ramp-nav-button no-transform bold  no-mobile">
          <b style="letter-spacing: 0;">Login</b>
      </v-btn>
      <v-btn
        v-if="accountMenu"
        variant="tonal"
        rounded="s"
        height="50"
        color="white"
        class="no-transform bold text-left mobile"
      >
        <v-icon class="mdi mdi-account"></v-icon>
        <v-spacer></v-spacer>
        <v-icon class="mdi mdi-menu-down"></v-icon>
        <v-menu activator="parent">
          <v-card min-width="300">
            <v-list>
              <span v-if="completeInfo">
                <v-list-item class="text-info">
                  <v-icon class="mdi mdi-account"></v-icon> {{ firstName }} {{ lastName }}
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item href="/dashboard/candidate" v-if="completeInfo.full_data.role.id==='377da95c-6518-4715-b32d-ac9825cb42bd'">
                  <span class="text-center"><v-icon class="mdi mdi-account-circle"></v-icon> My Account</span>
                </v-list-item>
                <v-list-item href="/dashboard" v-else>
                  <span class="text-center"><v-icon class="mdi mdi-account-circle"></v-icon> My Account</span>
                </v-list-item>
              </span>
              <v-list-item href="/careers" else>
                <span class="text-center"><v-icon class="mdi mdi-tie"></v-icon> Careers</span>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item @click="logOut" class="header-menu-logout">
                <span @click="logOut" class="text-center"><v-icon class="mdi mdi-logout-variant"></v-icon> Log-out</span>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </v-btn>
      <v-btn
        v-else
        variant="tonal"
        rounded="s"
        height="40"
        size="small"
        color="white"
        class="no-transform bold text-left mobile"
      >
        <v-spacer></v-spacer>
        <v-icon class="mdi mdi-menu"></v-icon>
        <v-menu activator="parent">
          <v-card min-width="300">
            <v-list>
              <v-list-item href="/careers" else>
                <span class="text-center"><v-icon class="mdi mdi-tie"></v-icon> Careers</span>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item class="header-menu text-blue" href="/registration">
                <span class="text-center"><v-icon class="mdi mdi-file-sign"></v-icon> Register</span>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item class="header-menu text-green" href="/login">
                <span class="text-center"><v-icon class="mdi mdi-login-variant"></v-icon> Login</span>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </v-btn>
  </v-app-bar>
</template>

<script lang="ts">
import { Item } from '@directus/sdk';
import { defineComponent } from 'vue';

export default defineComponent({
data() {
  return {
    isMinified: false,
    accountMenu: false,
    firstName: '',
    lastName: '',
    completeInfo: {} as Item,
  }
},
methods: {
  handleScroll() {
    this.isMinified = window.scrollY > 10
  },
  async logOut() {
    this.$router.push('/login');
    await this.$dataService.userLogout();
  },
  async verifyToken() {
    if(await this.$dataService.verifyToken())
    {
      this.accountMenu = true;
      const me = await this.$dataService.returnMe();
      this.firstName = me.firstName ?? '';
      this.lastName = me.lastName ?? '';
      this.completeInfo = me;
    }
  }
},
async mounted() {
  window.addEventListener('scroll', this.handleScroll)
  this.verifyToken();
},
beforeUnmount() {
  window.removeEventListener('scroll', this.handleScroll)
},
});
</script>

<style scoped>
.header-menu-logout
{
  color:red;
  cursor: pointer;
}
.header-minified {
  height: 64px !important; /* Adjust the height as needed */
  transition: height 1.0s; /* Adjust the transition duration as needed */
  transition: padding-top 0.5s; /* Adjust the transition duration as needed */
  padding-top:0 !important;
  background-color: var(--vt-c-indigo) !important;
}
.ramp-nav-item{
display: flex;
padding: 0px 25px;
height: 26.852px;
flex-direction: column;
flex-shrink: 0;
text-align:center;
color:#ffffff;
}
.ramp-nav-item:hover{
  background:transparent;
  color: var(--accent);
}
.ramp-nav-button{
margin: 0px 25px;
width: auto;
padding: 0 3rem;
background: var(--vt-c-yellow);
}
header{
background-color: transparent;
}
.ramp-app-bar{
flex-shrink: 0;
background-color: transparent;
padding-top:25px;
box-shadow:none !important;
margin: 0 auto;
right: 0;
}
.ramp-app-bar .v-toolbar-title {
margin-left: 0;
}
@media only screen and (max-width: 600px) {
  .no-mobile{ display:none; }
  .ramp-app-bar{ padding-top: 10px; }
}
@media only screen and (min-width: 601px) {
  .mobile{ display:none; }
}
</style>